module.exports = require('./helpers/bundle-url').getBundleURL('15MIF') + "aboutAlign.d9d43638.png";